import { useLayoutEffect } from 'react';
import { useFirstMountState } from 'react-use';

import { Duration } from 'utils/animateElement';

import { animateCollapse } from './utils/animateCollapse';
import { animateExpand } from './utils/animateExpand';

/**
 * Side-effect: animates `outerElement`'s height to match `innerHeight` when `isCollapsed` changes
 */
export const useAnimatedStylesOnToggle = (
  isCollapsed: boolean,
  outerElement: HTMLElement | null,
  innerHeight: number,
  duration: Duration,
) => {
  const isFirstRender = useFirstMountState();
  useLayoutEffect(() => {
    if (isFirstRender || !outerElement) return;
    const animate = isCollapsed ? animateCollapse : animateExpand;
    animate(outerElement, innerHeight, duration);
  }, [isCollapsed]);
};
